import {SurgeVariant} from './types'

export function beautifySurgeRatio(ratio: number): string {
  try {
    return ratio.toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1})
  } catch (err) {
    return ratio.toFixed(1)
  }
}

export function getSurgeVariant(ratio: number): SurgeVariant {
  if (ratio < 2) {
    return 'low'
  }

  if (ratio < 3) {
    return 'medium'
  }

  if (ratio < 4) {
    return 'high'
  }

  if (ratio < 5) {
    return 'ultra'
  }

  return 'max'
}
